import { Grid, type GridProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledGrid = styled(Grid)<GridProps>(({ theme }) => ({
  '&.MuiGrid-root': {
    display: 'grid',
    gridTemplateColumns: 'max-content',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    gap: theme.spacing(1),
    width: '100%',
    position: 'relative',
  },
}));
